export const modelNameEnCh={
    'NGS': '二代测序',
    'AMPLICON': '扩增子测序',
    'TGG': '三代测序',
    'METAPRO': '蛋白代谢组',
    'PURE': '纯分析',
    'PCR': '荧光定量',
    '二代测序': 'NGS',
    '扩增子测序': 'AMPLICON',
    '三代测序': 'TGG',
    '蛋白代谢组': 'METAPRO',
    '纯分析': 'PURE',
    '荧光定量': 'PCR',
}
